// extracted by mini-css-extract-plugin
export var rating = "StarRating-module--rating--cb59b";
export var ratingText = "StarRating-module--ratingText--96609";